import { jsonp, ajax, loadScript, cookie } from '@ifeng/ui_base';
import { formatImage, formatUrl } from 'ThreeTerminal_base/publicMethod';
import { getUserid, isArray, formatPlayTimes } from '@Container/common/client/utils/utils';
import { getPlantform } from '@Container/common/client/utils/nativeShare';
import { formatHotListData } from '@Container/common/client/utils/formatComment.js';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
const topicUrl = topicApiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

let host = '';

if (typeof window !== 'undefined') {
    host = window.location.host;
}

// 获取视频播放数
const getVideoComment = async vid => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonpCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

const getVideoRecomlist = async (guid, title) => {
    try {
        const data = await jsonp(
            `${apiBaseUrl}/api/videoRecom/getRecomlist/${guid}/${encodeURIComponent(title)}/getVideoRecomlist1`,
            {
                jsonpCallback: 'getVideoRecomlist1',
                cache: false,
            },
        );

        return data ? data : null;
    } catch (e) {
        console.error(e);
    }
};

// 获取自媒体账号的视频列表
const getWemediaVideoList = async id => {
    try {
        return await jsonp(`${apiBaseUrl}/api/video/getWeMediaListData/${id}/getWemediaVideoList1`, {
            jsonpCallback: 'getWemediaVideoList1',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

export { getVideoComment, getVideoRecomlist, getWemediaVideoList };
